import gamesConfig from './games.config';
import gamesComponent from './games.component';

export default angular.module('app.games', [
    'app.core'
])
.config(gamesConfig)
.component('gamesComponent', gamesComponent)
